// @flow
import { call, put, takeEvery } from 'redux-saga/effects'
import { BadResponseError, UnauthorizedError } from '../helpers'
import { sagaPatch } from '../fetch'
import { apiUrlV2ForPollWhereId } from '../urls'

import {
  setPollAutomatedFlagSuccess,
  setPollAutomatedFlagError,
} from '../stores/pollsStore'

import { TOOGLE_AUTOMATION_STATE } from '../stores/polls/automated'
import { sagaLogoutUnauthorizedUser } from './logout'

export function* setAutomatedPollSaga(): Generator<*, *, *> {
  return yield takeEvery(TOOGLE_AUTOMATION_STATE, function* automatedPoll(
    action
  ) {
    const { id, automationDisabled } = action.payload
    const url = apiUrlV2ForPollWhereId(id)
    const data = JSON.stringify({ automationDisabled })

    try {
      const response = yield call(sagaPatch, url, data, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })

      if (response.status === 401 || response.status === 403) {
        yield call(sagaLogoutUnauthorizedUser)
        throw new UnauthorizedError()
      }
      if (response.status === 404) return
      if (response.status !== 200) throw new BadResponseError(response)

      yield put(setPollAutomatedFlagSuccess(id, automationDisabled))
    } catch (error) {
      console.log(error)
      yield put(setPollAutomatedFlagError(id, automationDisabled))
    }
  })
}



// WEBPACK FOOTER //
// ./src/sagas/automatedPoll.js